var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14523_44800)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00037 4.56641C8.44707 4.56641 8.81255 4.93189 8.81255 5.37859V7.81514H11.2491C11.6958 7.81514 12.0613 8.18062 12.0613 8.62732C12.0613 9.07402 11.6958 9.4395 11.2491 9.4395H8.81255V11.8761C8.81255 12.3228 8.44707 12.6882 8.00037 12.6882C7.55367 12.6882 7.18818 12.3228 7.18818 11.8761V9.4395H4.75164C4.30494 9.4395 3.93945 9.07402 3.93945 8.62732C3.93945 8.18062 4.30494 7.81514 4.75164 7.81514H7.18818V5.37859C7.18818 4.93189 7.55367 4.56641 8.00037 4.56641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.626953C12.4264 0.626953 16 4.20056 16 8.62695C16 13.0533 12.4264 16.627 8 16.627C3.5736 16.627 0 13.0533 0 8.62695C0 4.20056 3.5736 0.626953 8 0.626953ZM8 1.68279C11.8173 1.68279 14.9442 4.80969 14.9442 8.62695C14.9442 12.4442 11.8173 15.5711 8 15.5711C4.18274 15.5711 1.05584 12.4442 1.05584 8.62695C1.05584 4.80969 4.18274 1.68279 8 1.68279Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14523_44800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.626953)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPlus);
export default __webpack_public_path__ + "static/media/NounPlus.16079cf1c9d6c5bb81015fa2a4641a9f.svg";
export { ForwardRef as ReactComponent };